// react core
import React, { useState } from 'react';
import { NotificationManager } from 'react-notifications'

// api
import {follow_tag, unfollow_tag} from 'commons/api';

// note:
// false means to follow
// true means to unfollow

// note:
// fontawesome don't trigger icon change see:
// https://stackoverflow.com/questions/49899245/setstate-not-updating-font-awesome-icon

export default function FollowTagButton({tag_id, tag_name, follow_state})
{
    const [state, set_state] = useState(follow_state);
    const handle_click_follow = (evt) =>
    {
        const post_data = async () =>
        {
            const res = await follow_tag(tag_id);
            const data = await res.json();
            if(data.status === 'ok')
            set_state(true);
        }
        post_data().then(function(data){
            NotificationManager.success('You are following ' + tag_name);
        });
    };

    const handle_click_unfollow = (evt) =>
    {
        const post_data = async () =>
        {
            const res = await unfollow_tag(tag_id);
            const data = await res.json();
            if(data.status === 'ok')
            set_state(false);
        }
        post_data().then(function(data){
            NotificationManager.warning('You are no more following ' + tag_name);
        });
    };

    if(state === false) return(
        <a key="one" onClick={handle_click_follow} className='button button-primary button-small'>
            <i className="fa-solid fa-bell">
            </i> Follow
        </a>
    );

    if(state === true) return(
        <a key="two" onClick={handle_click_unfollow} className='botton button-discreet button-small'>
            <i className="fa-solid fa-bell-slash">
            </i> Unfollow
        </a>
    );

    return (<></>)
}
